import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Diagnostic from "./pages/Diagnostic";
import Concluido from "./pages/Concluido";
import Report from "./pages/Report";
import Admin from "./pages/Admin";
import Landing from "./pages/Landing";
import Checklist from "./pages/Checklist";

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/checklist" element={<Checklist />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/diagnostico/:companyId" element={<Protected><Diagnostic /></Protected>} />
      <Route path="/concluido/:diagId" element={<Protected><Concluido /></Protected>} />
      <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
      <Route path="/relatorio/:diagId" element={<Protected admin><Report /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
